import React, {
	Component,
	PropTypes
} from 'react';
import {
	Link
} from "react-router";
import {getUserId,resultTip,errToSuc,language,errorShow} from "UTIL/common"
import bumpService from 'SERVICES/purifier/bump/bumpService'
import FormInput from 'CONFIG/component/form/formInput'
import Tip from 'CONFIG/component/tip'
import BoxHeader from "CONFIG/component/boxHeaderCreate"
import ContentHeader from 'CONFIG/component/contentHeaderLeft'
import FormSelectSimple from "../../../component/form/formSelectSimple";
import FormSelect from "../../../component/form/formSelect";
export default class PframeworkCreate extends Component {
	constructor(props) {
		super(props);
		this.submit = this.submit.bind(this);
		this.state = {
            bumpDvcTypes: [],
			msg: "",
            protocolCheckTypes:{}
		}
	}
	componentDidMount() {
		bumpService.pframeworkAdd().then(data=>{
			console.log(data)
            const json = data.data;
            this.setState({
                bumpDvcTypes: json.bumpDvcTypes,
                protocolCheckTypes : json.protocolCheckTypes,
            });
		})
	}
	submit(e) {
		e.preventDefault();
        errToSuc();
		const arr = {
            dvcTypeId: $.trim($("#dvcTypeId").val()),
            proName:  $.trim($("#proName").val()),
		}
		var errorMessage = '';
		for(let key in arr){
			if($.trim($("#"+key).val()) == ''){
				errorShow(key)
			}
		}
		if($("[name='error']").length == 0){
            const data = JSON.stringify(arr);
            bumpService.pframeworInsertOrUpdate({data}).then(body=>{
                resultTip(body,'/config/pframework/pframeworkIndex')
            })
		}

	}
	render() {
        const dvcTypeList = this.state.bumpDvcTypes.map(function (str,index) {
            return <option key={index} value={str.id}>{str.name}</option>
        })
		return (
			<div >
				<section className="content-header">
		            <h1> {language()['proDefinition']} <small>{language()['proAdd']}</small> </h1>
		        </section>
				<section className="content" >
					<div className="box box-primary color-palette-box">
						<BoxHeader name={language()['proAdd']}/>
						<div className="box-body">
							<Tip ids=""/>
							<form className="form-horizontal">
								<div className="row form-group">
									<label  className="multi-label control-label col-xs-2">{language()['ModelCategory']}</label>
									<div className="col-xs-3">
										<select  className="form-control" id='dvcTypeId'>
                                            {dvcTypeList}
										</select>
									</div>
								</div>
								<FormInput id="proName" name="proName"/>
							</form>
						</div>
						<div className="box-footer">
								<div className="col-xs-2"></div>
								<div className="col-xs-1 text-center">
									<Link  to = "/config/pframework/pframeworkIndex" className="btn btn-default btn-md">
										{language()['return']}
									</Link>
								</div>
								<div className="col-xs-1 text-center">
									<button className="btn btn-success" id="btnSubmit" onClick={this.submit.bind(this)}>{language()['submit']}</button>
								</div>
						</div>
					</div>
				</section>
		    </div>

		)
	}
}


// WEBPACK FOOTER //
// ./modules/bump/config/pframework/pframeworkCreate.js